import React from "react";
import {Input} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import styled from "styled-components";

const SearchContainer = styled.div`
    padding: 8px;
    padding-bottom: 8px;
    margin: 0 8px;

    .ant-input-affix-wrapper {
        background-color: rgba(255, 255, 255, 0.1) !important;
        border-color: rgba(255, 255, 255, 0.3) !important;

        &:hover {
            border-color: rgba(255, 255, 255, 0.5) !important;
            background-color: rgba(255, 255, 255, 0.15) !important;
        }

        &.ant-input-affix-wrapper-focused {
            border-color: rgba(255, 255, 255, 0.6) !important;
            box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1) !important;
            background-color: rgba(255, 255, 255, 0.15) !important;
        }
    }

    input.ant-input,
    .ant-input,
    .ant-input-affix-wrapper input {
        background-color: transparent !important;
        border: none !important;
        color: #ffffff !important;
        font-size: 14px !important;
        -webkit-text-fill-color: #ffffff !important;

        &::placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
            -webkit-text-fill-color: rgba(255, 255, 255, 0.5) !important;
        }

        &::-webkit-input-placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
            -webkit-text-fill-color: rgba(255, 255, 255, 0.5) !important;
        }

        &::-moz-placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
            opacity: 1;
        }

        &:-ms-input-placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
        }
    }

    .anticon-search {
        color: rgba(255, 255, 255, 0.7) !important;
    }

    .anticon-close-circle {
        color: rgba(255, 255, 255, 0.7) !important;

        &:hover {
            color: rgba(255, 255, 255, 0.9) !important;
        }
    }
`;

export const MenuSearch = ({value, onChange}) => {
    return (
        <SearchContainer>
            <Input
                prefix={<SearchOutlined />}
                placeholder="Ara..."
                value={value}
                onChange={e => onChange(e.target.value)}
                allowClear
                style={{width: "100%"}}
            />
        </SearchContainer>
    );
};
